"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _icon = _interopRequireDefault(require("../icon"));

var _notification = _interopRequireDefault(require("../notification"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var cx = _bind["default"].bind(_style["default"]);

var Input = function Input(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'input' : _ref$as,
      input = _ref.input,
      _ref$meta = _ref.meta,
      meta = _ref$meta === void 0 ? {
    touched: false,
    error: null,
    warning: null
  } : _ref$meta,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      offset = _ref.offset,
      dock = _ref.dock,
      placeholder = _ref.placeholder,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      _ref$focused = _ref.focused,
      focused = _ref$focused === void 0 ? false : _ref$focused,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$disabledLimitati = _ref.disabledLimitationMinWidth,
      disabledLimitationMinWidth = _ref$disabledLimitati === void 0 ? false : _ref$disabledLimitati,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      icon = _ref.icon,
      customIcon = _ref.customIcon,
      extra = _ref.extra,
      onClick = _ref.onClick,
      style = _ref.style,
      containerRef = _ref.containerRef,
      className = _ref.className,
      _ref$validationAppear = _ref.validationAppearance,
      validationAppearance = _ref$validationAppear === void 0 ? 'default' : _ref$validationAppear,
      dataIdError = _ref.dataIdError,
      notificationClassName = _ref.notificationClassName,
      rest = _objectWithoutProperties(_ref, ["as", "input", "meta", "type", "size", "appearance", "offset", "dock", "placeholder", "inline", "focused", "disabled", "disabledLimitationMinWidth", "readOnly", "icon", "customIcon", "extra", "onClick", "style", "containerRef", "className", "validationAppearance", "dataIdError", "notificationClassName"]);

  var showValidationMessage = validationAppearance === 'default';
  var isError = meta.touched && meta.error;
  var isWarning = meta.touched && !meta.error && meta.warning;
  var inputName = input.name || '';
  var errorDataId = dataIdError || "error-".concat(inputName);
  var warningDataId = "warning-".concat(inputName);
  return /*#__PURE__*/_jsx("div", {
    style: _objectSpread({
      display: inline ? 'inline-block' : 'block'
    }, style)
  }, void 0, /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    style: {
      position: 'relative',
      width: '100%',
      display: inline ? 'inline-block' : 'block'
    }
  }, /*#__PURE__*/React.createElement(readOnly ? 'button' : as, _objectSpread(_objectSpread(_objectSpread({}, rest), input), {}, {
    placeholder: placeholder,
    disabled: disabled,
    onClick: onClick,
    className: cx('xsui-input', "xsui-input--size-".concat(size), appearance && "xsui-input--appearance-".concat(appearance), offset && "xsui-input--offset-".concat(offset), focused && 'xsui-input--focused', disabledLimitationMinWidth && 'xsui-input--disabled-min-width', readOnly && !input.value && 'xsui-input--empty', readOnly && 'xsui-input--read-only', isError && 'xsui-input--error', isWarning && 'xsui-input--warning', dock && "xsui-input--dock-".concat(dock), className),
    value: input.value === null || input.value === void 0 ? '' : String(input.value),
    type: readOnly ? 'button' : type,
    children: readOnly ? input.value || placeholder : null,
    'data-id': inputName,
    'data-value': input.value
  })), icon && /*#__PURE__*/_jsx("div", {
    className: cx('xsui-input__icon')
  }, void 0, /*#__PURE__*/_jsx(_icon["default"], {
    name: icon
  })), customIcon && /*#__PURE__*/_jsx("div", {
    className: cx('xsui-input__icon')
  }, void 0, /*#__PURE__*/_jsx("img", {
    src: customIcon
  })), extra && /*#__PURE__*/_jsx("div", {
    className: cx('xsui-input__extra')
  }, void 0, extra)), showValidationMessage && /*#__PURE__*/_jsx("div", {
    className: cx(notificationClassName)
  }, void 0, isError && /*#__PURE__*/_jsx(_notification["default"], {
    appearance: "string",
    status: "error"
  }, void 0, /*#__PURE__*/_jsx("span", {
    "data-id": errorDataId
  }, void 0, meta.error)), isWarning && /*#__PURE__*/_jsx(_notification["default"], {
    appearance: "string",
    status: "warning"
  }, void 0, /*#__PURE__*/_jsx("span", {
    "data-id": warningDataId
  }, void 0, meta.warning))));
};

var _default = Input;
exports["default"] = _default;